import { render, staticRenderFns } from "./OrganisationsSearchView.vue?vue&type=template&id=87925c12&scoped=true&"
import script from "./OrganisationsSearchView.vue?vue&type=script&lang=js&"
export * from "./OrganisationsSearchView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87925c12",
  null
  
)

export default component.exports